import { render } from "./relatorioMes.vue?vue&type=template&id=28e4c85f&scoped=true"
import script from "./relatorioMes.vue?vue&type=script&lang=js"
export * from "./relatorioMes.vue?vue&type=script&lang=js"

import "./relatorioMes.vue?vue&type=style&index=0&id=28e4c85f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e4c85f"]])

export default __exports__